import React, {FC} from 'react';

import {Skeleton} from '@optimaxdev/design-system';
import {Exit, Icon} from '@optimaxdev/icons';

import {CartIcon} from 'desktopMiniCart/cartIcon/cartIcon';

import s from './miniCartHeader.scss';

type PropsType = {
    closeDrawer: () => void;
    isLoading: boolean;
};

/**
 *  mini cart drawer header
 */
export const MiniCartHeader: FC<PropsType> = ({closeDrawer, isLoading}) => (
    <div className={s.miniCartHeaderContainer}>
        {isLoading ? (
            <Skeleton className={s.headerSkeleton} />
        ) : (
            <div className={s.cartInfoContainer}>
                <CartIcon />
                <h2 className={s.title}>Shopping Cart</h2>
            </div>
        )}
        <div className={s.closeButtonContainer}>
            <button onClick={closeDrawer} type="button">
                <Icon className={s.closeIcon} icon={Exit} />
            </button>
        </div>
    </div>
);
